import React from 'react'
import Layout from '../components/Layout'
import RichText from '../components/RichText'

function ArticleCard({ title, description, link }) {
  return (
    <article className="card p-4 mb-4">
      <h4 className="text-brand-dark font-semibold mb-2 uppercase">{title}</h4>
      <RichText content={description} className="text-gray-700 text-justify mb-3" />
      <p className="text-right">
        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="link inline-flex items-center gap-1"
          >
            ver mais
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        ) : (
          <span className="text-gray-400 text-sm">link indisponível</span>
        )}
      </p>
    </article>
  )
}

export default function Publicacoes({ title, publications = [] }) {
  return (
    <Layout>
      <div className="bg-brand-bg min-h-screen py-8">
        <div className="container mx-auto px-4">
          <div className="flex items-center mb-8">
            <h3 className="text-brand-light font-bold uppercase text-xl">{title}</h3>
            <hr className="flex-1 ml-4 border-0 h-[1px] bg-brand-light" />
          </div>

          <div className="space-y-4">
            {publications.map((pub, index) => (
              <ArticleCard key={index} {...pub} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
